import { useState } from 'react';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import NewsCard from '@/components/feature/NewsCard';
import { news } from '@/mocks/news';
import { usePageMeta } from '@/hooks/usePageMeta';

const STEP = 4;

export default function NewsPage() {
  const [visible, setVisible] = useState(STEP);

  usePageMeta({
    title: '影视行业新闻 - 河马AV',
    description:
      '河马AV影视行业新闻频道，汇集最新作品动态、剧集观察、行业分析与影展资讯，帮助您了解影视圈正在发生的事。',
    keywords: '影视新闻,行业动态,影视资讯,河马AV,剧集观察',
  });

  const articles = news.slice(0, visible);
  const hasMore = visible < news.length;

  return (
    <Layout>
      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-5xl px-4 py-8 md:px-6 md:py-10">
          <Breadcrumb items={[{ label: '影视行业新闻' }]} />
          <div className="mt-4">
            <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              影视行业新闻
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              最新作品动态、剧集观察与行业分析，共 {news.length} 篇资讯
            </p>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-5xl px-4 py-8 md:px-6 md:py-10">
        {news.length === 0 ? (
          <div className="flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-20 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-3xl text-secondary-500">
              <i className="ri-newspaper-line" />
            </span>
            <h2 className="mt-5 font-heading text-lg font-bold text-foreground-900">暂无资讯文章</h2>
            <p className="mt-2 text-sm text-foreground-500">新的影视资讯正在整理中，请稍后再来查看。</p>
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-4">
              {articles.map((article) => (
                <NewsCard key={article.id} article={article} variant="list" />
              ))}
            </div>

            {hasMore ? (
              <div className="mt-10 flex justify-center">
                <button
                  type="button"
                  onClick={() => setVisible((v) => v + STEP)}
                  className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className="ri-add-line" />
                  加载更多资讯
                </button>
              </div>
            ) : (
              <p className="mt-10 text-center text-sm text-foreground-400">已经到底啦，感谢阅读</p>
            )}
          </>
        )}
      </div>
    </Layout>
  );
}